const statusFilterOptions = [
  {
    option: "All",
    value: "",
  },
  {
    option: "Pending",
    value: 0,
  },
  {
    option: "Approved",
    value: 1,
  },
  {
    option: "Rejected",
    value: 2,
  },
];

export { statusFilterOptions };
